import { FC } from 'react';

import { ExclamationCircleSolid, Flex, StyleProps, Text, useFormControlContext } from '@bonusly/design-system';

type FormErrorMessageProps = StyleProps & {
	children?: string;
};

export const FormErrorMessage: FC<FormErrorMessageProps> = ({ children, ...rest }) => {
	const form = useFormControlContext();

	if (!form.isInvalid) {
		return null;
	}

	return (
		<Flex {...rest} mt={1}>
			<ExclamationCircleSolid color="error.text" size="sm" mr={1} />
			<Text color="error.text" size="sm">
				{children}
			</Text>
		</Flex>
	);
};
